import { PropsWithChildren, memo } from "react";
import { church } from "src/core/church/church";

interface Props {}

/**
 * The church's photo, or without one, its brand colour turned a little round the hue, as its
 * icons are. A browser without relative colours gets the brand colour flat.
 */
const backdrop = () =>
    church.images.photo
        ? `url(${church.images.photo})`
        : "linear-gradient(135deg, oklch(var(--p)), oklch(from oklch(var(--p)) l c calc(h + 25)))";

export const SplitImageLayout = memo((props: PropsWithChildren<Props>) => (
    <main className="bg-no-repeat bg-cover bg-center bg-primary" style={{ backgroundImage: backdrop() }}>
        <div className="grid md:grid-cols-2">
            <div className="relative">
                <div className="absolute bg-gradient-to-b from-base-300 to-base-200 opacity-75 inset-0 z-0" />
            </div>

            <div className="flex h-screen bg-base-100">{props.children}</div>
        </div>
    </main>
));
